module.exports = __webpack_public_path__ + "static/domestic_mental_obj01@2x-041f8fac11057843916ce9d0e5892bbf.jpg";